import type { StatusTone } from "../formatting/status";

/**
 * `StatusPill` (REDISENO-PANEL.md §2 "Estados como pill", panel-redesign-v3
 * T1) — a true pill (`border-radius:9999px`), 6px dot + 12px/600 text, one
 * tone per `StatusTone` including the new `live` tone (`enviando`).
 *
 * Deliberately a separate component/CSS from the existing `StatusBadge`
 * (`.v2-status`, 4px radius, 500 weight): this slice is foundations-only
 * (§2) and does not redesign any screen yet, so existing StatusBadge
 * consumers (CampaignListScreen, CampaignDetailScreen, CampaignSummaryTab,
 * OverviewScreen, CampaignSelector, TelemetryScreen) are left untouched and
 * migrate to StatusPill in their own later slice. Same accessible-name
 * contract as StatusBadge: the dot is `aria-hidden`, the visible text label
 * is what keeps status from being conveyed by color alone.
 */
export function StatusPill({ label, tone }: { label: string; tone: StatusTone }) {
  return (
    <span className={`v3-status-pill v3-status-pill--${tone}`}>
      <span className="v3-status-pill__dot" aria-hidden="true" /> {label}
    </span>
  );
}
